import { Modal } from '@mui/material';

import closeIcon from '@/assets/icons/modal-window/close.svg';

import { useModal } from '@/hooks/useModal';

import { LeadForm } from '../LeadForm';
import { OrderForm } from '../OrderForm';

import styles from './ModalWindow.module.scss';

export const ModalWindow = () => {
  const { isModalOpened: isModalVisible, closeModal: hideModal, contentType } = useModal();

  return (
    <Modal className={styles.modalWindow} open={isModalVisible} onClose={() => hideModal()}>
      <div className={styles.modalWindow__content}>
        {contentType === 'consult' && <LeadForm modal />}
        {contentType === 'order' && <OrderForm />}
        <button className={styles.modalWindow__close} onClick={() => hideModal()}>
          <img src={closeIcon} alt="Close" />
        </button>
      </div>
    </Modal>
  );
};
